import React from "react";
import { Button, ImageKit, Typography } from "@aph/ui-lib-humanx";
import styles from "./ErrorScreen.module.scss";

interface ErrorScreenProps {
  errorImage?: any;
  onClick?: (e?: any) => void;
  prefixTitle?: string;
  postfixTitle?: string;
  subTitle?: string;
  ctaText?: string;
  alt?: any;
}

const ErrorScreen: React.FC<ErrorScreenProps> = (props) => {
  const { errorImage, prefixTitle, postfixTitle, subTitle, ctaText, onClick, alt = "Error screen" } = props;

  return (
    <div className={styles.errorScreenRoot}>
      <div className={` ${styles.leftSection}`}>
        <div className={styles.infoSection}>
          <Typography component="h2" className={styles.title}>
            <span>{prefixTitle}</span> {postfixTitle}
          </Typography>
          {subTitle && (
            <Typography component="p" className={styles.subTitle}>
              {subTitle}
            </Typography>
          )}
          {ctaText && (
            <Button color="primarybaby" className={styles.ctaBtn} title={ctaText} onClick={onClick}>
              {ctaText}
            </Button>
          )}
        </div>
      </div>
      {errorImage && (
        <div className={`${styles.imageBx}`}>
          <ImageKit src={errorImage} alt={alt} height={308} width={424} />
        </div>
      )}
    </div>
  );
};

export default ErrorScreen;
